export const menuItems = [
  {
    label: "Dashboard",
    icon: "uil-chart-pie",
    href: "/dashboard",
  },
  {
    label: "Customer Area",
    icon: "feather feather-users",
    isSvg: true,
    subItems: [
      { label: "My Customer(s)", icon: "uil-user-circle", link: "/customers" },
      { label: "My Booking(s)", icon: "uil-calendar-alt", link: "/bookings" },
      { label: "Find Plot(s)", icon: "uil-map-marker", link: "/find-plots" },
      { label: "My Hold List(s)", icon: "uil-list-ul", link: "/hold-list" },
    ],
  },
  {
    label: "Team Area",
    icon: "uil-sitemap",
    subItems: [
      {
        label: "My Team Tree View",
        icon: "uil-sitemap",
        link: "/team-tree-view",
      },
      { label: "My Sponsor Line", icon: "uil-notes", link: "/sponsor-line" },
      {
        label: "New Associate",
        icon: "uil-comment-plus",
        link: "/new-associate",
      },
    ],
  },
  {
    label: "Business Area",
    icon: "uil-analytics",
    subItems: [
      { label: "My Business", icon: "uil-atom", link: "/my-business" },
      { label: "My Wallet(S)", icon: "uil-wallet", link: "/my-wallets" },
      // { label: "Withdrawal Request", icon: "uil-wallet", link: "/withdrawal-request" },
      {
        label: "Withdrawal list(S)",
        icon: "uil-wallet",
        link: "/withdrawal-list",
      },
      { label: "My Payouts", icon: "uil-wallet", link: "/my-payouts" },
    ],
  },
  {
    label: "Site Visit Area",
    icon: "uil-map-marker-alt",
    subItems: [
      // { label: "Request Site Visit", icon: "uil-comment-check", link: "/site-visit-request" },
      {
        label: "Site Visit List",
        icon: "uil-comment-check",
        link: "/site-visit-list",
      },
    ],
  },
  {
    label: "Support Ticket Area",
    icon: "uil-servers",
    subItems: [
      // { label: "Create Support Ticket", icon: "uil-ticket", link: "/create-support-ticket" },
      {
        label: "Support Ticket List",
        icon: "uil-ticket",
        link: "/support-ticket-list",
      },
    ],
  },
  {
    label: "My Reports",
    icon: "uil-coins",
    subItems: [
      {
        label: "My Business Detail",
        icon: "uil-notes",
        link: "/business-detail",
      },
      {
        label: "My Payout Report",
        icon: "uil-file-question-alt",
        link: "/payout-report",
      },
      {
        label: "Annual Incentive Status",
        icon: "uil-file-check-alt",
        link: "/annual-incentive",
      },
      { label: "My Founder Club", icon: "uil-dropbox", link: "/founder-club" },
      { label: "My GST Report", icon: "uil-moneybag", link: "/gst-report" },
      { label: "My TDS Report", icon: "uil-moneybag", link: "/tds-report" },
      {
        label: "My Reward Status",
        icon: "uil-comment-plus",
        link: "/my-rewards",
      },
      { label: "My Rank", icon: "uil-comment-plus", link: "/my-rank" },
    ],
  },
  {
    label: "Promotional Tools",
    icon: "uil-chat-bubble-user",
    subItems: [
      {
        label: "My Registered Events",
        icon: "uil-comment-plus",
        link: "/my-registered-events",
      },
      {
        label: "Dholera",
        icon: "uil-store",
        link: "https://drive.google.com/drive/folders/1oZEeTAVZvw7W8cBdrP8kz2Q2asIG18Fu",
      },
      {
        label: "The River Castle",
        icon: "uil-store",
        link: "https://drive.google.com/drive/folders/1P6TABUqe0KSDaqtvNEKjjxIQRnRHWsPv",
      },
    ],
  },
];
